import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BlockableDiv } from '../../../../../shared/controls/blockable-div/blockable-div.component';
import { I18nService } from '../../../../../@core/services/i18n/i18n.service';
import { NotificationService } from '../../../../../@core/services/notification/notification.service';
import { BaseDetailComponent } from '../../../../../common/base-detail.component';
import { Address } from '../../../../../generated/generated-types';
import { ShippingMethodAddressLinkListWidgetComponent } from '../shipping-method-address-link-list-widget/shipping-method-address-link-list-widget.component';

@Component({
  selector: 'app-formly-shipping-method-address-link-widget',
  templateUrl: './formly-shipping-method-address-link-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ShippingMethodAddressLinkListWidgetComponent,
    BlockableDiv,
    ButtonModule,
    TooltipModule,
    TranslatePipe,
  ]
})
export class FormlyShippingMethodAddressLinkWidgetComponent extends FieldType {

  isSaving: boolean = false;

  cdRef = inject(ChangeDetectorRef);
  constructor(
    private notificationService: NotificationService,
    private i18n: I18nService
  ) {
    super();
  }

  checkIfCanSave() {
    let component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    return component.detailForm.invalid;
  }

  async saveToUnlockEditMode() {

    //Other options would be to use the service, but special overwrite in the component wont be used then

    let component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    if (!component) {
      console.error("No detail component found to save ShippingMethodAddressLink");
      return;
    }

    this.isSaving = true;
    this.cdRef.detectChanges();

    await component.save();

    this.isSaving = false;
    this.cdRef.detectChanges();
  }

}
